/*
 * Created by TUTEHUB.
 * Copyright © TUTEHUB. All rights reserved.
 * ------------------------
 * Non-disclosure Terms
 * ------------------------
 * These codes are TUTEHUB's property, as the developer, such as employee, contractor, and intern, working for TUTEHUB cannot disclose, spread, copy, preserve, sell, and do other activities without the consent of TUTEHUB.
 * Technique Support: jobyme88.com
 */

import React from 'react'
import {Col} from 'react-bootstrap'
import './qrBlock.scss'

export default function QRBlock(props) {
    return (

        <Col>
            <img src={"./assets/images/" + props.img + ".avif"} alt="" className="mb-3" />
            <p>{props.des}</p>
        </Col>
    )
}
